export class CameraProcess {

    FACING_MODE_ENVIRONMENT = 'environment';
    FACING_MODE_USER = 'user';
    IMAGE_MIME = 'image/png';
    QUALITY_IMAGE = 1;
    MARK_RATIO = 63 / 100;
    MARK_MARGIN = 25;

    customRequestAnimationFrame = () => {
        const alternativeFunction = (callback) => {
            window.setTimeout(callback, 33)
        };

        const result = window.requestAnimationFrame
            || window.webkitRequestAnimationFrame
            || window.mozRequestAnimationFrame
            || window.msRequestAnimationFrame
            || alternativeFunction;

        return result;
    };

    initCamera = (errCallBack, video, canvasVideo, shadow, facingMode) => {

        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }

        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = (constraints) => {

                // First get ahold of the legacy getUserMedia, if present
                const getUserMedia = (
                    navigator.getUserMedia
                    || navigator.webkitGetUserMedia
                    || navigator.mozGetUserMedia
                    || navigator.msGetUserMedia
                );

                // Some browsers just don't implement it - return a rejected promise with an error
                // to keep a consistent interface
                if (!getUserMedia) {
                    return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                }

                // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            }
        }


        let constrains = true;

        if (facingMode) {
            constrains = {
                facingMode: facingMode || this.FACING_MODE_USER
            };
        }

        const mediaStreamConstraints = {
            audio: false,
            video: constrains,
        };

        navigator.mediaDevices.getUserMedia(mediaStreamConstraints)
            .then((stream) => {
                video.srcObject = stream;
                return navigator.mediaDevices.enumerateDevices();
            })
            .catch((error) => {
                errCallBack(error);
            });

        video.addEventListener('play', () => {
            const canvasSize = this.camResize(canvasVideo, video);
            this.maskSize(shadow, canvasSize);
            canvasVideo.style.display = 'block';
            canvasVideo.width = canvasSize.width;
            canvasVideo.height = canvasSize.height;
            const step = () => {
                const ctx = canvasVideo.getContext('2d');
                ctx.drawImage(video, 0, 0, canvasSize.width, canvasSize.height);
                this.customRequestAnimationFrame()(step);
            };
            this.customRequestAnimationFrame()(step);
        });
    };

    camResize = (canvasVideo, video) => {
        const screenSize = {width: window.innerWidth, height: window.innerHeight};
        const videoSize = {width: video.videoWidth, height: video.videoHeight};
        const videoResize = {};
        if (screenSize.width > screenSize.height) {
            videoResize.width = screenSize.height * videoSize.width / videoSize.height;
            videoResize.height = screenSize.height;
        } else {
            videoResize.width = screenSize.width;
            videoResize.height = screenSize.width * video.videoHeight / video.videoWidth;
        }
        return videoResize;
    };

    maskSize = (shadow, videoSize) => {
        const size = {};
        size.width = videoSize.width - (this.MARK_MARGIN * 2);
        size.height = size.width * this.MARK_RATIO;
        shadow.style.height = `${size.height}px`;
        shadow.style.width = `${size.width}px`;
        shadow.style.outlineWidth = `${(videoSize.height - size.height) / 2}px`;
        shadow.style.display = 'block';

    };

    pixelToPercent = (referencePx, px) => {
        return px * 100 / referencePx;
    };


    play = async (video, canvasVideo) => {
        this.camResize(canvasVideo, video);
        await video.play();
    };

    capture = async (video) => {
        await video.pause();
        const canvas = document.createElement('canvas');
        canvas.height = video.videoHeight;
        canvas.width = video.videoWidth;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL(this.IMAGE_MIME, this.QUALITY_IMAGE);
    }

}

export default new CameraProcess();